var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteRedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.063,
    height: 18.547,
    viewBox: "0 0 15.063 18.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115398",
    "data-name": "Group 115398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107387",
    "data-name": "Path 107387",
    d: "M222.833,154.7a.434.434,0,0,0-.434.434v8.209a.434.434,0,0,0,.869,0v-8.209A.434.434,0,0,0,222.833,154.7Zm0,0",
    transform: "translate(-212.738 -147.984)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107388",
    "data-name": "Path 107388",
    d: "M104.833,154.7a.434.434,0,0,0-.434.434v8.209a.434.434,0,1,0,.869,0v-8.209A.434.434,0,0,0,104.833,154.7Zm0,0",
    transform: "translate(-99.864 -147.984)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107389",
    "data-name": "Path 107389",
    d: "M1.23,5.52v10.7a2.4,2.4,0,0,0,.637,1.653,2.139,2.139,0,0,0,1.552.671h8.218a2.138,2.138,0,0,0,1.552-.671,2.4,2.4,0,0,0,.637-1.653V5.52A1.659,1.659,0,0,0,13.4,2.257H11.177V1.714A1.706,1.706,0,0,0,9.457,0H5.6A1.706,1.706,0,0,0,3.88,1.714v.543H1.656A1.659,1.659,0,0,0,1.23,5.52ZM11.637,17.677H3.419A1.376,1.376,0,0,1,2.1,16.222V5.558H12.957V16.222A1.376,1.376,0,0,1,11.637,17.677ZM4.749,1.714A.837.837,0,0,1,5.6.867H9.457a.837.837,0,0,1,.851.847v.543H4.749ZM1.656,3.126H13.4a.782.782,0,0,1,0,1.564H1.656a.782.782,0,0,1,0-1.564Zm0,0",
    transform: "translate(0.003 0.001)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107390",
    "data-name": "Path 107390",
    d: "M163.833,154.7a.434.434,0,0,0-.434.434v8.209a.434.434,0,1,0,.869,0v-8.209A.434.434,0,0,0,163.833,154.7Zm0,0",
    transform: "translate(-156.301 -147.984)",
    fill: "red"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/delete_red_icon.91b9e6e56d679ef191d5d0f87deb5b90.svg";
export { ForwardRef as ReactComponent };